export type Lang = 'en' | 'es';

/** First run on a device: the browser's language (Spanish when it prefers Spanish), until one is chosen. */
export function browserLang(langs: readonly string[] | undefined = typeof navigator === 'undefined' ? undefined : navigator.languages): Lang {
  const first = (langs ?? []).find((l) => /^(en|es)(-|$)/i.test(l));
  return first && /^es(-|$)/i.test(first) ? 'es' : 'en';
}
